var exports = {
  "vW": "xdde3148b--371947--inner",
  "DD": "xdde3148b--371947--title",
  "Qs": "xdde3148b--371947--content",
  "qr": "xdde3148b--371947--footer",
};

module.exports = exports;
